function handleAlert({ commit, dispatch }, result, error) {
  if (result) {
    commit("Alert/SET_IS_ALERT", result.meta, { root: true });
  }
  if (error) {
    commit("Alert/SET_IS_ALERT", error.meta, { root: true });
  }
  dispatch("Alert/removeAlerts", 1, { root: true });
}

export default handleAlert;
